import TextInput from "../../../components/TextInput";
import SearchButton from "../../../components/SearchButton";
import RefreshButton from "../../../components/RefreshButton";
import MultiSelectInput from "../../../components/MultiSelectInput";
import { BarsArrowUpIcon } from "@heroicons/react/24/solid";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { Disclosure } from "@headlessui/react";
import { useSFGetOffice } from "../OfficeSettings/hooks/useSFGetOffice";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import SelectInput from "../../../components/SelectInput";
import { useStates } from "../hooks/useStates";
import {
  defaultProdCodeSearchParams,
  franchiseFilterState,
  fromRecentActivity,
  searchDataProducerCode,
} from "./atom";
import { toast } from "../../../components/toastNotification";
import { useGetCarrierNameLists } from "./hooks/useGetActiveCarrierList";
import { useGetBilling } from "./hooks/useGetBilling";
import { useGetDistributionChannels } from "./hooks/useGetDashboardFilterOptions";
import { useMemo } from "react";

const TableFilters = ({
  searchProducerCode,
  setFilteredproducerCodeData,
  setIsFilterMainTable,
  setIsSearchClick,
}) => {
  const user = useRecoilValue(accountAtom);
  const setIsFranchiseFilter = useSetRecoilState(franchiseFilterState);
  const [searchInputsData, setSearchInputsData] = useRecoilState(
    searchDataProducerCode
  );
  const setFromRecents = useSetRecoilState(fromRecentActivity);
  const { data: agenciesQuery, isLoading } = useSFGetOffice();
  const agencies =
    agenciesQuery &&
    agenciesQuery
      ?.filter((c) => c.officeCode !== null && c.officeCode !== "")
      .map((resData) => ({
        label:
          resData.officeName +
          "-" +
          resData.officeCode +
          "-" +
          (resData.storeNumber !== "" ? resData.storeNumber : "0"),
        value: resData.officeCode,
        state: resData.stateCode,
        officeName: resData.officeName + "-" + resData.officeCode,
      }));
  const { data: stateQuery } = useStates();
  const states =
    stateQuery &&
    stateQuery?.map((data) => {
      return { label: data.state, value: data.state };
    });

  const { data: carriersQuery } = useGetCarrierNameLists();
  const carriers =
    carriersQuery &&
    carriersQuery.map((resData) => ({
      label: resData.carrierName,
      value: resData.masterCarrierId,
    }));

  const refreshProducerCode = () => {
    setIsFilterMainTable(false);
    setIsSearchClick(false);
    setSearchInputsData(defaultProdCodeSearchParams);
    setFilteredproducerCodeData([]);
    setFromRecents(false);
  };

  const handleFieldChange = (value, fieldName, selectedFieldName) => {
    const selectedField = selectedFieldName;
    setSearchInputsData({
      ...searchInputsData,
      [fieldName]: value,
      [selectedField]: value,
    });
  };

  const handleFranchiseConfieSelect = (selected) => {
    setSearchInputsData((prev) => ({
      ...prev,
      selectedFranchiseConfie: selected ?? null,
      DistributionChannelId: null,
      DistributionChannelName: null,
    }));
  };

  const { data: billing } = useGetBilling();
  const billingOpt = billing?.map((x) => ({
    label: x.billingName,
    value: x.billingId,
  }));

  const franchiseOption = {
    label: "Franchise",
    value: -1,
  };

  const { data: distChannels, isLoading: channelLoading } =
    useGetDistributionChannels();

  const franchiseORConfie = [
    { label: "Confie", value: 0 },
    { label: "Franchise", value: 1 },
    { label: "Freeway Franchise", value: 3 },
  ];

  const distributionOpts = useMemo(() => {
    const channelOptions =
      distChannels?.map((x) => ({
        label: x.channelName,
        value: x.channelId,
      })) || [];

    const selected = searchInputsData?.selectedFranchiseConfie?.value;
    let allowedChannels: { label: string; value: number }[] = [];

    if (user.isFranchise && !user.isNonFranchise) {
      allowedChannels = [franchiseOption];
    } else if (!user.isFranchise && user.isNonFranchise) {
      allowedChannels = channelOptions;
    } else if (user.isFranchise && user.isNonFranchise) {
      allowedChannels = [...channelOptions, franchiseOption];
    }
    if (selected === 1 || selected === 3) {
      return [franchiseOption];
    }

    if (selected === 0) {
      return channelOptions;
    }

    return allowedChannels;
  }, [distChannels, user, searchInputsData?.selectedFranchiseConfie]);

  const statusOptions: any = ["Active", "Inactive", "Suspended"].map(
    (status) => ({
      label: status,
      value: status.toLowerCase(),
    })
  );

  const searchMutation = () => {
    if (
      searchInputsData.CarrierName?.length === 0 &&
      searchInputsData.OfficeName?.length === 0 &&
      searchInputsData.State?.length === 0 &&
      searchInputsData.ProducerCode === "" &&
      searchInputsData.MAProducerCode === "" &&
      searchInputsData.AcquisitionName === "" &&
      !searchInputsData.selectedFranchiseConfie &&
      searchInputsData?.BillingId === null &&
      searchInputsData?.DistributionChannelId === null &&
      searchInputsData?.Status?.length === 0
    ) {
      toast.fire("Error", "Search fields must be filled!", "error");
    } else {
      searchProducerCode();
      setIsSearchClick(true);
    }
  };

  return (
    <div className="pt-1 space-y-2">
      <div>
        <BarsArrowUpIcon className="h-6 w-6 text-primary mb-1.5" />
        <div className="text-xl font-bold text-primary -mt-9 ml-8">
          Search Section
        </div>
      </div>
      <div className="w-full ">
        <div className="mb-3">
          <Disclosure defaultOpen>
            {({ open }) => (
              <>
                <Disclosure.Button className="sm:px-2 flex justify-between w-full mb-2 px-4 py-2 text-sm font-medium text-left text-primary bg-gray-100 rounded-t-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                  <span>Producer Code Details</span>
                  <ChevronDownIcon
                    className={`${
                      open ? "transform rotate-180" : ""
                    } w-5 h-5 text-gray-500`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="bg-gray-100 text-sm text-primary rounded-b-lg">
                  <div className="w-full">
                    <div className="flex flex-col text-xs gap-y-2 p-3 sm:px-2 md:px-3 -mt-2">
                      {user.isFranchise && user.isNonFranchise ? (
                        <div className="w-full">
                          <label className="block font-medium text-gray-700 mb-2">
                            Franchise/Confie
                          </label>
                          <div className="w-full">
                            <SelectInput
                              options={franchiseORConfie}
                              value={searchInputsData.selectedFranchiseConfie}
                              onChange={(options) => {
                                handleFranchiseConfieSelect(options);
                                setIsFranchiseFilter(true);
                              }}
                              className={undefined}
                              components={undefined}
                              field={undefined}
                              isLoading={undefined}
                            />
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}

                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          States
                        </label>
                        <div className="w-full">
                          <MultiSelectInput
                            options={states?.filter(
                              (v, i, a) =>
                                a.findIndex(
                                  (t) =>
                                    t.label === v.label && t.value === v.value
                                ) === i
                            )}
                            value={searchInputsData.selectedState}
                            handleMultiSelect={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                State:
                                  e?.length > 0
                                    ? e.map((x) => x.label)
                                    : refreshProducerCode(),
                                selectedState:
                                  e?.length > 0 ? e : refreshProducerCode(),
                              });
                            }}
                            defaultValue={undefined}
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Carriers
                        </label>
                        <div className="sm:w-full md:w-full lg:w-full">
                          <MultiSelectInput
                            options={carriers?.filter(
                              (v, i, a) =>
                                a.findIndex(
                                  (t) =>
                                    t.label === v.label && t.value === v.value
                                ) === i
                            )}
                            className="sm:w-full md:w-full lg:w-full"
                            value={searchInputsData.selectedCarrier}
                            handleMultiSelect={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                CarrierName:
                                  e?.length > 0
                                    ? e.map((x) => x.label)
                                    : refreshProducerCode(),
                                selectedCarrier:
                                  e?.length > 0 ? e : refreshProducerCode(),
                              });
                            }}
                            defaultValue={undefined}
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Offices
                        </label>
                        <div className="sm:w-full md:w-full lg:w-full">
                          <MultiSelectInput
                            isDisabled={isLoading}
                            options={agencies?.filter(
                              (v, i, a) =>
                                a.findIndex(
                                  (t) =>
                                    t.label === v.label && t.value === v.value
                                ) === i
                            )}
                            className="sm:w-full md:w-full lg:w-full"
                            value={searchInputsData.selectedOffice}
                            handleMultiSelect={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                OfficeName:
                                  e?.length > 0
                                    ? e.map((x) => x.label)
                                    : refreshProducerCode(),
                                OfficeCode:
                                  e?.length > 0
                                    ? e.map((x) => x.value)
                                    : refreshProducerCode(),
                                selectedOffice:
                                  e?.length > 0 ? e : refreshProducerCode(),
                              });
                            }}
                            defaultValue={undefined}
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          {"Producer Code/Princeton Code"}
                        </label>
                        <div className="sm:w-full md:w-full lg:w-full">
                          <TextInput
                            name="ProducerCode"
                            value={searchInputsData.selectedProducerCode}
                            onChange={(e) => {
                              handleFieldChange(
                                e.target.value,
                                "ProducerCode",
                                "selectedProducerCode"
                              );
                            }}
                            className="mr-18 outline-none focus:ring-septenary focus:border-septenary"
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          {"M&A Producer Code"}
                        </label>
                        <div className="sm:w-full md:w-full lg:w-full">
                          <TextInput
                            name="MAProducerCode"
                            value={searchInputsData.selectedMaProducerCode}
                            onChange={(e) => {
                              handleFieldChange(
                                e.target.value,
                                "MAProducerCode",
                                "selectedMaProducerCode"
                              );
                            }}
                            className="mr-18 outline-none focus:ring-septenary focus:border-septenary"
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          {"Acquisition Name"}
                        </label>
                        <div className="sm:w-full md:w-full lg:w-full">
                          <TextInput
                            name="acquisitionName"
                            value={searchInputsData.selectedAcquisitionName}
                            onChange={(e) => {
                              handleFieldChange(
                                e.target.value,
                                "AcquisitionName",
                                "selectedAcquisitionName"
                              );
                            }}
                            className="mr-18 outline-none focus:ring-septenary focus:border-septenary"
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Billing
                        </label>
                        <div className="w-full">
                          <SelectInput
                            options={billingOpt}
                            value={searchInputsData.BillingName}
                            onChange={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                BillingName: e ? e : "",
                                BillingId: e ? e.value : null,
                              });
                            }}
                            className={undefined}
                            components={undefined}
                            field={undefined}
                            isLoading={undefined}
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <div className="block font-medium text-gray-700 mb-2">
                          Distribution Channel
                        </div>
                        <div className="mt-2">
                          <SelectInput
                            options={distributionOpts}
                            value={searchInputsData.DistributionChannelName}
                            onChange={(e) => {
                              setSearchInputsData((prev) => ({
                                ...prev,
                                DistributionChannelName: e ?? null,
                                DistributionChannelId: e?.value ?? null,
                              }));
                            }}
                            className={undefined}
                            components={undefined}
                            field={undefined}
                            isLoading={channelLoading}
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <div className="block font-medium text-gray-700 mb-2">
                          Producer Code Status
                        </div>
                        <div className="mt-2">
                          <MultiSelectInput
                            options={statusOptions}
                            value={searchInputsData.selectedStatus}
                            handleMultiSelect={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                selectedStatus: e || [],
                                Status: e?.map((status) => status.value) ?? [],
                              });
                            }}
                            defaultValue={undefined}
                          />
                        </div>
                      </div>
                      <div className="place-self-center">
                        <div className="flex flex-row gap-3 justify-center m-3">
                          <SearchButton
                            buttonValue="Search"
                            onClick={() => {
                              searchMutation();
                            }}
                          />
                          <RefreshButton
                            onClick={() => {
                              refreshProducerCode();
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      </div>{" "}
    </div>
  );
};

export default TableFilters;
